export interface IToast {
  title: string;
  message: string;
  duration: number;
  position: string;
  class: string;
  icon: string;
}

export class Toast {
  id: number;
  title: string;
  message: string;
  duration: number;
  position: string;
  class: string;
  icon: string;

  constructor(model: IToast) {
    Object.assign(this, model);
  }
}
